import HTTPRequest from '../index'

export type Credentials = {
  email?: string
  password?: string
}

const apiPath = '/api/v2/users/web-login'
const sendMailResetPassApiPath = '/api/v2/users/send-email-reset'
const resetPassApiPath = '/api/v2/users/reset-password'
const apiLinkLine = '/api/v2/users/link-line'
const settingPassApiPath = '/api/v2/users/setting-password'
const sendMailSettingPassApiPath = '/api/v2/users/send-email-setting-pwd'

class Auth extends HTTPRequest {
  login(value: Credentials) {
    return this.post(`${apiPath}`, { ...value })
  }

  sendMailResetPassword(value: MailResetPassType) {
    return this.post<Response.SendMessageSuccessType>(
      `${sendMailResetPassApiPath}`,
      {
        ...value,
      },
    )
  }

  resetPassword(value: ResetPasswordType) {
    return this.post<Response.SendMessageSuccessType>(`${resetPassApiPath}`, {
      ...value,
    })
  }

  linkLine(data) {
    return this.put(`${apiLinkLine}`, data)
  }

  sendMailSettingPassword(value: MailSettingPassType) {
    return this.post<Response.SendMessageSuccessType>(
      `${sendMailSettingPassApiPath}`,
      {
        ...value,
      },
    )
  }

  settingPassword(value: SettingPasswordType) {
    return this.post<Response.SendMessageSuccessType>(`${settingPassApiPath}`, {
      ...value,
    })
  }
}

export type MailResetPassType = {
  email?: string
}

export type MailSettingPassType = MailResetPassType

export type ResetPasswordType = {
  password: string
  password_confirmation: string
  email: string
  token: string
}

export type SettingPasswordType = ResetPasswordType

export default new Auth()
